/**
 * ExploreBadge — badge persistente del overlay de nivel (plan 38 F3).
 *
 * Recuerda al usuario que está "explorando" otro nivel temporalmente, sin que se
 * confunda con su nivel real (el caso Marcelo: verbalizar un nivel desincronizado
 * sin marcarlo churnea). Tocarlo abre el `LevelExploreSheet` (cambiar/volver).
 *
 * Sólo se renderiza cuando hay overlay activo (el caller lo gatea con
 * `level.levelOverlay`).
 */
import type { CefrLevel, ExploreCefrLevel } from '../../../lib/englishApi.js';

interface ExploreBadgeProps {
  exploring: ExploreCefrLevel;
  realLevel: CefrLevel;
  onOpen: () => void;
}

export function ExploreBadge({ exploring, realLevel, onOpen }: ExploreBadgeProps) {
  return (
    <button type="button" className="explore-badge" onClick={onOpen}>
      <span className="explore-badge-dot" aria-hidden="true" />
      <span className="explore-badge-tx">
        Explorando <b>{exploring}</b> · tu nivel es <b>{realLevel}</b>
      </span>
      <span className="explore-badge-cta">Cambiar</span>
    </button>
  );
}
